import { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { HiOutlineMenu, HiOutlineX } from "react-icons/hi";
import { useLocation, useNavigate } from "react-router-dom";
import { CiSearch, CiFilter } from "react-icons/ci";
import FilterModal from '../moduls/FilterModal'
import { PiUserCircleFill } from "react-icons/pi";
import CargoService from "../../../../services/Cargo";
import React from "react";

 function AdsHeader({ search,filterItems=[],setSearch=()=>{} ,setFilterItems=()=>{},setFilterFlag=()=>{}}) {



    const navigate = useNavigate();
    const [mobileOpen, setMobileOpen] = useState(false);
    const location = useLocation();
    const toggleRef = useRef(null);
    const [flagOrigin, setFlagOrigin] = useState("state")
    const [originStateId, setOriginStateId] = useState(null);
    const [allState, setAllState] = useState([])
    const [allCarType, setAllCarType] = useState([])
    const [localSearch,setLocalSearch]=useState(search)
    const [openFilter, setOpenFilter] = useState(false);







    //state
    async function getAllState() {
        try {

            const res = await CargoService.getAllState()
            setAllState(res?.data?.data)


        } catch (err) {
            console.log(err)
        }
    }






    useEffect(() => {
        getAllState()
    }, [])


    useEffect(() => {
        if (flagOrigin === "state") {
            setFilterItems(prev =>
                prev.map((item, idx) =>
                    idx === 1
                        ? { ...item, sub: allState }
                        : item
                )
            )
        }


    }, [flagOrigin, allState])

    async function getAllCar() {
        try {

            const res = await CargoService.getAllCarType()
            setAllCarType(res?.data?.data)


        } catch (err) {
            console.log(err)
        }
    }

    useEffect(() => {
        getAllCar()
    }, [])

    //car
    useEffect(() => {


        setFilterItems(prev =>
            prev.map((item, idx) =>
                idx === 3
                    ? { ...item, sub: allCarType }
                    : item
            )
        )

    }, [allCarType])

        ;

    useEffect(() => {
        function handleClickOutside(e) {
            if (toggleRef.current?.contains(e.target)) return;
            setOpenFilter(false);
        }
        document.addEventListener("click", handleClickOutside);
        return () => document.removeEventListener("click", handleClickOutside);
    }, []);



    async function fetchCitiesForState(state_id, search = "") {
        try {
            const res = await CargoService.getAllCity({ search, state_id });
            const data = res?.data?.data || [];

            return data;
        } catch (err) {

            return [];
        }
    }

    async function handleOnOptionClick(main, subItem, index) {
        if (main === "شهر") {

            if (flagOrigin === "state") {

                try {
                    const cities = await fetchCitiesForState(subItem._id, "");
                    setOriginStateId(subItem._id);
                    setFlagOrigin("city");

                    setFilterItems(prev =>
                        prev.map((item, idx) =>
                            idx === index
                                ? {
                                    ...item,
                                    sub: cities,
                                    selected: `${subItem.name}`,
                                    selectedVal: { state: subItem._id, city: null },
                                    enable: true
                                }
                                : item
                        )
                    );

                } catch (err) {

                }

                return
            } else {

                setFilterItems(prev =>
                    prev.map((item, idx) =>
                        idx === index
                            ? {
                                ...item,
                                selected: `${item.selected} , ${subItem.name}`,
                                selectedVal: { state: subItem.state_id ?? originStateId, city: subItem._id },
                                enable: false
                            }
                            : item
                    )
                );
                setFlagOrigin("state");

            }
            return;
        }
        // Generic handler for non-city filter options: set selected value and collapse the submenu
        // This ensures clicking price/model/type/etc. will stick in the filter UI
        setFilterItems(prev =>
            prev.map((item, idx) => {
                if (idx !== index) return item;
                const selectedLabel = subItem?.name ?? subItem?.label ?? String(subItem ?? '');
                const selectedVal = subItem?._id ?? subItem?.id ?? subItem?._id ?? subItem?.value ?? selectedLabel;
                return {
                    ...item,
                    selected: selectedLabel,
                    selectedVal,
                    enable: false,
                };
            })
        );
    }

    async function handleSearchToggle(search, index) {
        setFilterItems((prev) =>
            prev.map((item, idx) => {
                if (idx !== index) return item;

                const originalSub = item.subOriginal || item.sub;

                const filteredSub = search
                    ? originalSub.filter((subItem) =>
                        subItem.name.toLowerCase().includes(search.toLowerCase())
                    )
                    : originalSub;

                const shouldExpand =
                    filteredSub.length > 0 && !(search && search.trim().length > 0);

                return {
                    ...item,
                    sub: filteredSub,
                    subOriginal: originalSub,
                    expanded: shouldExpand ? idx : null,
                };
            })
        );
    }


    function handleSearch(){
        setSearch(localSearch)
    }

    const links = [
        { name: "خانه", to: "/" },
        { name: "بار", to: "/cargo" },
        { name: "راننده", to: "/driver/cargo" },
        { name: "فروشگاه", to: "/market" },
        { name: "معامله و اجاره خودرو", to: "/ads" },
        { name: "درباره ما", to: "/about" },
        { name: "تماس با ما", to: "/contact" },
    ];

    const handleNavigate = () => {
        navigate("/registerAds");
    };

    return (
        <header className="min-w-full bg-white z-50 fixed md:px-10">
            {/* Desktop Header */}
            <div className="hidden md:flex justify-between items-center mt-5 px-8 h-[70px]">
                <div className="flex w-full justify-start items-center">
                    <div className="w-[80px] h-full rounded-md overflow-hidden">
                        <img className="w-[60px] h-[60px] object-contain" src="/icon-512.png" alt="Logo" />
                    </div>

                    <div className="w-1/2 max-w-[600px] relative">
                    <input
                        type="text"
                        value={localSearch}
                        onChange={(e) => setLocalSearch(e.target.value)}
                        placeholder="جستجو کنید"
                        onClick={(e) => e.stopPropagation()} 
                        className="w-full h-[30px] text-sm border border-gray-500 rounded-xl px-7 focus:outline-none focus:ring-2 focus:ring-special"
                    />
                        <span className="absolute right-2 top-1/2 -translate-y-1/2 text-black">
                            <CiSearch onClick={handleSearch}  />
                        </span>
                        <button
                            ref={toggleRef}
                            onClick={(e) => {
                                e.stopPropagation();
                                setOpenFilter(prev => !prev); 
                            }}
                            className="absolute left-2 top-1/2 -translate-y-1/2 text-gray-500 flex items-center gap-1 text-xs"
                        >
                            <CiFilter /> فیلترها
                        </button>

                        {openFilter && (
                            <FilterModal
                                toggleRef={toggleRef}
                                filterItems={filterItems}
                                setFilterItems={setFilterItems}
                                handleSearchToggle={handleSearchToggle}
                                onOptionClick={handleOnOptionClick}
                                onClose={() => setOpenFilter(false)}
                             
                                setSearch={setSearch}
                            />
                        )}
                    </div>
                </div>
                <div className="hidden md:flex gap-5 items-center text-[12px] pl-5 lg:text-[16px]">
                    <Link to={"/ads/dashboard"} className="flex flex-col items-center gap-1 w-max">
                        <PiUserCircleFill size={22} className="text-special"></PiUserCircleFill>
                        <p className="lg:text-[14px] text-[12px] text-special">حساب کاربری</p>
                    </Link>
                </div>

                <button
                    onClick={handleNavigate}
                    className="w-[140px] h-[40px] bg-special text-white rounded-lg flex items-center justify-center gap-2"
                >
                    ثبت آگهی جدید
                </button>
            </div>

            {/* Desktop Nav */}
            <nav className="hidden md:flex justify-start bg-white my-2">
                <ul className="flex gap-8 text-gray-700 text-[12px] lg:text-[16px] px-8">
                    {links.map((item, idx) => {
                        const isActive = location.pathname === item.to;
                        return (
                            <li key={idx} className="relative group">
                                <Link
                                    to={item.to}
                                    className={`transition-all duration-200 hover:text-special hover:scale-105 ${isActive ? "text-special font-[16px]" : ""}`}
                                >
                                    {item.name}
                                    <span className="absolute left-0 bottom-0 w-0 h-[2px] bg-special group-hover:w-full transition-all duration-300"></span>
                                </Link>
                            </li>
                        );
                    })}
                </ul>
            </nav>

            {/* Mobile Header */}
            <div className="md:hidden flex flex-col gap-3 px-4 py-3 bg-white">
                <div className="flex justify-between items-center">
                    <div className="w-[60px] h-[60px]">
                        <img className="w-full h-full object-contain" src="/icon-512.png" alt="Logo" />
                    </div>
                    <button onClick={() => setMobileOpen(!mobileOpen)} className="text-2xl text-gray-700">
                        {mobileOpen ? <HiOutlineX /> : <HiOutlineMenu />}
                    </button>
                </div>

                <div className="flex justify-between items-center gap-2">
                    <div className="flex-1 relative">
                        <input
                          value={localSearch}
                          onChange={(e) => setLocalSearch(e.target.value)}
                            type="text"
                            placeholder="جستجو کنید"
                            className="w-full h-[40px] text-sm border border-gray-500 rounded-xl px-7 focus:outline-none focus:ring-2 focus:ring-special"
                        />
                        <span className="absolute right-2 top-1/2 -translate-y-1/2 text-black">
                            <CiSearch onClick={handleSearch} />
                        </span>
                        <button
                            ref={toggleRef}
                            onClick={(e) => {
                                e.stopPropagation();
                                setOpenFilter(prev => !prev); 
                            }}
                            className="absolute left-2 top-1/2 -translate-y-1/2 text-gray-500 flex items-center gap-1 text-xs"
                        >
                            <CiFilter /> فیلترها
                        </button>
                    

                        {openFilter && (
                            <div className="absolute right-80 top-1/2">
                            <FilterModal
                                toggleRef={toggleRef}
                                filterItems={filterItems}
                                setFilterItems={setFilterItems}
                                handleSearchToggle={handleSearchToggle}
                                onOptionClick={handleOnOptionClick}
                                onClose={() => setOpenFilter(false)}
                                setSearch={setSearch}
                                setFilterFlag={setFilterFlag}
                            />
                            </div>
                        )}
                    </div>

                    <button
                        onClick={handleNavigate}
                        className="flex-1 h-[40px] max-w-[120px] bg-special text-white rounded-lg flex items-center justify-center gap-2"
                    >
                        ثبت آگهی جدید
                    </button>
                </div>

                {mobileOpen && (
                    <nav className="bg-white mt-2 shadow-md">
                        <ul className="flex flex-col gap-4 p-4 text-gray-700">
                            {links.map((item, idx) => (
                                <li key={idx} onClick={() => setMobileOpen(false)} className="h-6 py-1">
                                    <Link
                                        to={item.to}
                                        className="block transition-all duration-200 hover:text-special hover:underline decoration-special underline-offset-4"
                                    >
                                        {item.name}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </nav>
                )}
            </div>
        </header>
    );
}
export default React.memo(AdsHeader)
